import { useTranslation } from "react-i18next";
import { NeuInput } from "../../components/neu/Neu";
import { PasswordPair } from "../../components/neu/PasswordPair";

const latinOnly = (value) => value.replace(/[^A-Za-z\s'.-]/g, "");

// حقول هوية الموظف عند الانضمام: الاسم اللاتيني، كلمة المرور وتأكيدها، والهاتف.
export const JoinFields = ({ form, setForm }) => {
  const { t } = useTranslation();
  return (
    <div className="mt-4 grid gap-3">
      <div>
        <NeuInput
          data-testid="join-name"
          dir="ltr"
          lang="en"
          placeholder={t("join.nameEn")}
          value={form.name}
          onChange={(e) => setForm({ ...form, name: latinOnly(e.target.value) })}
        />
        <p className="mt-1 text-[11px] text-muted-foreground">{t("join.nameHint")}</p>
      </div>
      <PasswordPair
        testId="join-password"
        password={form.password}
        confirm={form.confirm}
        onPasswordChange={(password) => setForm({ ...form, password })}
        onConfirmChange={(confirm) => setForm({ ...form, confirm })}
        passwordPlaceholder={t("auth.password")}
        confirmPlaceholder={t("join.confirmPassword")}
      />
      <NeuInput
        data-testid="join-phone"
        dir="ltr"
        inputMode="tel"
        placeholder={t("detail.phone")}
        value={form.phone}
        onChange={(e) => setForm({ ...form, phone: e.target.value })}
      />
    </div>
  );
};
